export const CHAPTER_NAVIGATION_WIDTH: number = 220;
export const PADDING: number = 15;
